var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"mod-interrupt361",attrs:{"width":350,"visible":_vm.visible,"closable":true,"append-to-body":true,"footer":null},on:{"close":_vm.close}},[(_vm.visible)?_c('iframe',{staticClass:"interrupt-iframe",attrs:{"src":_vm.sourceUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }